import {
  ApiGetHook,
  ApiMutateHook,
  useApiGet,
  useApiMutate,
} from "@skanska/vsa-client-auth";
import { ApiEndpoints } from "../models/ApiEndpoints";
import { ApiMethods } from "../models/ApiMethods";
import {
  LibraryFilterScope,
  UpsertUserLibraryFilterStateRequest,
  UserLibraryFilterState,
} from "../models/UserLibraryFilterState";

const USER_LIBRARY_FILTER_STATE_CACHE_KEY = "user-library-filter-state";

const buildStateEndpoint = (scope?: LibraryFilterScope) => {
  if (!scope) {
    return ApiEndpoints.UserLibraryFiltersState;
  }

  const listType = encodeURIComponent(scope.listType);

  return `${ApiEndpoints.UserLibraryFiltersState}?listType=${listType}`;
};

const buildStateCacheKey = (scope?: LibraryFilterScope) => [
  USER_LIBRARY_FILTER_STATE_CACHE_KEY,
  scope?.listType ?? "disabled",
];

export function useGetUserLibraryFilterState(
  scope?: LibraryFilterScope
): ApiGetHook<UserLibraryFilterState | null> {
  return useApiGet<UserLibraryFilterState | null>(
    buildStateEndpoint(scope),
    null,
    buildStateCacheKey(scope),
    { enabled: Boolean(scope) }
  );
}

export function useSaveUserLibraryFilterState(): ApiMutateHook<
  UserLibraryFilterState,
  UpsertUserLibraryFilterStateRequest
> {
  return useApiMutate<
    UserLibraryFilterState,
    UpsertUserLibraryFilterStateRequest
  >(
    ApiEndpoints.UserLibraryFiltersState,
    ApiMethods.Put,
    null,
    USER_LIBRARY_FILTER_STATE_CACHE_KEY,
    [USER_LIBRARY_FILTER_STATE_CACHE_KEY]
  );
}

export function useClearUserLibraryFilterState(
  scope?: LibraryFilterScope
): ApiMutateHook<void, void> {
  return useApiMutate<void, void>(
    buildStateEndpoint(scope),
    ApiMethods.Delete,
    null,
    buildStateCacheKey(scope),
    [USER_LIBRARY_FILTER_STATE_CACHE_KEY]
  );
}
